import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Anagrafica from "@/pages/Anagrafica";
import GuardiaDetail from "@/pages/GuardiaDetail";
import MiaScheda from "@/pages/MiaScheda";
import Sync from "@/pages/Sync";
import Interventi from "@/pages/Interventi";
import Turni from "@/pages/Turni";
import Presenze from "@/pages/Presenze";
import Pagamenti from "@/pages/Pagamenti";
import DonazionePubblica from "@/pages/DonazionePubblica";
import VerificaPubblica from "@/pages/VerificaPubblica";
import Convenzioni from "@/pages/Convenzioni";
import SitoUfficiale, { SitoGalleria, SitoNotizie, SitoNotizia, SitoPagina, SitoGestione } from "@/pages/SitoUfficiale";
import Galleria from "@/pages/Galleria";
import Scadenze from "@/pages/Scadenze";
import Utenti from "@/pages/Utenti";
import Documenti from "@/pages/Documenti";

function HomeRedirect() {
  const { user } = useAuth();
  if (user?.role === "guardia") return <Navigate to="/mia-scheda" replace />;
  return <Dashboard />;
}

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <RoutedApp />
      </BrowserRouter>
    </div>
  );
}

function RoutedApp() {
  const location = useLocation();
  // Process the Emergent OAuth callback before any route/auth check runs
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dona" element={<DonazionePubblica />} />
      <Route path="/verifica/:id" element={<VerificaPubblica />} />
      <Route path="/convenzioni" element={<Convenzioni />} />
      <Route path="/sito" element={<SitoUfficiale />} />
      <Route path="/sito/galleria" element={<SitoGalleria />} />
      <Route path="/sito/p/:slug" element={<SitoPagina />} />
      <Route path="/sito/gestione" element={<ProtectedRoute roles={["admin","coordinatore"]}><SitoGestione /></ProtectedRoute>} />
      <Route path="/sito/notizie" element={<SitoNotizie />} />
      <Route path="/sito/notizie/:id" element={<SitoNotizia />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route path="/" element={<Shell><HomeRedirect /></Shell>} />
      <Route path="/mia-scheda" element={<Shell><MiaScheda /></Shell>} />
      <Route path="/galleria" element={<Shell><Galleria /></Shell>} />
      <Route path="/turni" element={<Shell><Turni /></Shell>} />
      <Route path="/interventi" element={<Shell><Interventi /></Shell>} />
      <Route path="/presenze" element={<Shell><Presenze /></Shell>} />
      <Route path="/pagamenti" element={<Shell><Pagamenti /></Shell>} />
      <Route path="/documenti" element={<Shell><Documenti /></Shell>} />

      <Route path="/scadenze" element={<ProtectedRoute roles={["admin","coordinatore","territoriale","com_distaccamento"]}><AppLayout><Scadenze /></AppLayout></ProtectedRoute>} />

      <Route path="/anagrafica" element={<ProtectedRoute roles={["admin","coordinatore"]}><AppLayout><Anagrafica /></AppLayout></ProtectedRoute>} />
      <Route path="/guardie/:id" element={<ProtectedRoute roles={["admin","coordinatore"]}><AppLayout><GuardiaDetail /></AppLayout></ProtectedRoute>} />
      <Route path="/sync" element={<ProtectedRoute roles={["admin","coordinatore"]}><AppLayout><Sync /></AppLayout></ProtectedRoute>} />
      <Route path="/utenti" element={<ProtectedRoute roles={["admin","coordinatore"]}><AppLayout><Utenti /></AppLayout></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
